export default __webpack_public_path__ + "static/media/frontpage.e3f2fc25.txt";